// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 227 ? "chunk-echarts" : chunkId) + "." + {"9":"7fbe5198","227":"2eb63787","257":"b0ae986e","272":"83c3d0c2","444":"b89b9541","556":"f1f9c0d4","601":"b73c8b6e","758":"0951f8ea","879":"ea78f866","913":"18890844","927":"209b53d1","929":"5fd6106e"}[chunkId] + ".js";
};